import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AdminPendingActionsVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const adminRetrievePendingActions = createAsyncThunk<AdminPendingActionsVM, void, { extra: Partial<Dependencies> }>(
  "admin/adminRetrievePendingActions",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.hasPendingActions();
  },
);
